let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9V1or")).then(() => parcelRequire('f3ggR'));